// voglio che sia salvato tutto nel SESSION STORAGE
// import storage from 'redux-persist/lib/storage/session'
import storage from 'redux-persist/lib/storage'

import { configureStore } from '@reduxjs/toolkit'

import {
  persistReducer, persistStore,
  FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE
} from 'redux-persist'


import { componentStatusReducer } from '../slices/LoginSlice'

/**
 * Configurazione dello store
 */
const persistConfig = {
    key: 'area-personale',  // nome dello store --- attenzione alla lunghezza.. con howdenReservation non crea l'entry!
    storage: storage,       // voglio che sia nel SESSION STORAGE
    debug: false            // abilitare per loggare il debug in console
}


// associo il reducer generale al session storage (su cui deve scrivere)
const rootReducer = persistReducer( persistConfig, componentStatusReducer )

// creo lo store
export const store = configureStore ({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, PAUSE, REHYDRATE, PERSIST, PURGE, REGISTER]
      }
    }),
    devTools: process.env.NODE_ENV !== 'production',
})

// creo ed esporto il persitor (che si occupa di salvare i dati nello storage)
export const persistor = persistStore( store )